import useBreakpoints from "./useBreakpoints";

export const useNormalizeFontSize = () => {
	const {
		smDown: isMobileDown,
		smUp: isTabletUp,
		mdUp: isDesktopUp,
		lgUp: isLargeDesktopUp,
	} = useBreakpoints();

	const normalizeFontSize = (size: number) => {
		if (isLargeDesktopUp) {
			return Math.round(size * 1.6);
		}

		if (isDesktopUp) {
			return Math.round(size * 1.4);
		}

		if (isTabletUp) {
			return Math.round(size * 1.2);
		}

		if (isMobileDown) {
			return size;
		}

		return size;
	};

	return { normalizeFontSize };
};
